/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 休憩リポート
 * @export
 * @interface BreakReportsRow
 */
export interface BreakReportsRow {
    /**
     * 乗務日
     * @type {number}
     * @memberof BreakReportsRow
     */
    shiftDate?: number;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof BreakReportsRow
     */
    driverId?: number;
    /**
     * 乗務員名
     * @type {string}
     * @memberof BreakReportsRow
     */
    driverName?: string;
    /**
     * 乗務時間
     * @type {number}
     * @memberof BreakReportsRow
     */
    shiftLenMin?: number;
    /**
     * 営業所ID
     * @type {number}
     * @memberof BreakReportsRow
     */
    officeId?: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof BreakReportsRow
     */
    officeName?: string;
    /**
     * 休憩時間（一回）
     * @type {number}
     * @memberof BreakReportsRow
     */
    breakSec?: number;
    /**
     * 休憩時間（総合）
     * @type {number}
     * @memberof BreakReportsRow
     */
    breakLenMin?: number;
    /**
     * 休憩位置
     * @type {string}
     * @memberof BreakReportsRow
     */
    breakCityName?: string;
    /**
     * 休憩開始
     * @type {string}
     * @memberof BreakReportsRow
     */
    breakStartTs?: string;
    /**
     * 要指導
     * @type {string}
     * @memberof BreakReportsRow
     */
    needGuidance?: string;
    /**
     * record unique ID
     * @type {string}
     * @memberof BreakReportsRow
     */
    recId?: string;
    /**
     * 休憩位置座標(lat)
     * @type {number}
     * @memberof BreakReportsRow
     */
    breakLocLat?: number;
    /**
     * 休憩位置座標(lng)
     * @type {number}
     * @memberof BreakReportsRow
     */
    breakLocLng?: number;
}

export function BreakReportsRowFromJSON(json: any): BreakReportsRow {
    return BreakReportsRowFromJSONTyped(json, false);
}

export function BreakReportsRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakReportsRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftDate': !exists(json, 'shift_date') ? undefined : json['shift_date'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'shiftLenMin': !exists(json, 'shift_len_min') ? undefined : json['shift_len_min'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeName': !exists(json, 'office_name') ? undefined : json['office_name'],
        'breakSec': !exists(json, 'break_sec') ? undefined : json['break_sec'],
        'breakLenMin': !exists(json, 'break_len_min') ? undefined : json['break_len_min'],
        'breakCityName': !exists(json, 'break_city_name') ? undefined : json['break_city_name'],
        'breakStartTs': !exists(json, 'break_start_ts') ? undefined : json['break_start_ts'],
        'needGuidance': !exists(json, 'need_guidance') ? undefined : json['need_guidance'],
        'recId': !exists(json, 'rec_id') ? undefined : json['rec_id'],
        'breakLocLat': !exists(json, 'break_loc_lat') ? undefined : json['break_loc_lat'],
        'breakLocLng': !exists(json, 'break_loc_lng') ? undefined : json['break_loc_lng'],
    };
}

export function BreakReportsRowToJSON(value?: BreakReportsRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_date': value.shiftDate,
        'driver_id': value.driverId,
        'driver_name': value.driverName,
        'shift_len_min': value.shiftLenMin,
        'office_id': value.officeId,
        'office_name': value.officeName,
        'break_sec': value.breakSec,
        'break_len_min': value.breakLenMin,
        'break_city_name': value.breakCityName,
        'break_start_ts': value.breakStartTs,
        'need_guidance': value.needGuidance,
        'rec_id': value.recId,
        'break_loc_lat': value.breakLocLat,
        'break_loc_lng': value.breakLocLng,
    };
}


